<div class="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
  <div class="row w-100 justify-content-center">
    <div class="col-md-7 col-lg-6">
      <div class="card shadow-lg border-0 rounded-4">
        <div class="card-body p-5 text-center">
          <!-- Lock Icon -->
          <div class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" class="bi bi-lock text-danger" viewBox="0 0 16 16">
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
            </svg>
          </div>

          <!-- Main Message -->
          <h1 class="display-5 fw-bold text-danger mb-3">ไม่ได้รับอนุญาต</h1>
          <p class="lead text-muted mb-4">
            คุณไม่มีสิทธิ์เข้าถึงหน้านี้<br>
            <br>
            หรืออาจจะเกิดจากเวลาบนเครื่องของคุณไม่ตรงกับเวลาบนเซิร์ฟเวอร์
          </p>

          <!-- Thai Clock Display -->
          <div class="alert alert-info rounded-3 mb-4">
            <h6 class="mb-2 fw-bold">เวลาปัจจุบันบนเครื่องของคุณ</h6>
            <div class="d-flex justify-content-around flex-wrap gap-3">
              <div>
                <strong>{{ localTime }}</strong>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-grid gap-2 d-md-flex justify-content-center">
            <button class="btn btn-outline-primary px-4" (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>ย้อนกลับ
            </button>
            <button class="btn btn-primary px-4" (click)="goHome()">
              <i class="bi bi-house-door me-2"></i>กลับหน้าหลัก
            </button>
          </div>

          <!-- OIDC Tip -->
          <div class="mt-4 pt-3 border-top">
            <p class="text-muted medium mb-0">
              ⚠️ หากเวลาเครื่องไม่ตรงกับเวลาเซิร์ฟเวอร์ กรุณาปรับเวลาเครื่องให้ตรงกับเวลาจริง หรือเปิดการตั้งเวลาอัตโนมัติ
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
